import Layout from 'components/Layout';
import {
  createBrowserRouter,
  RouterProvider
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { work, works, home } from 'utils/api';
import Company from 'routes/company';
import Services from 'routes/services';
import CaseStudy from 'routes/case-study';
import Contact from 'routes/contact';
import Home from 'routes/home';
import OurValues from 'routes/our-values';
import PrivacyPolicy from 'routes/privacy-policy';
import TermsServices from 'routes/terms-of-services';
import Work from 'routes/work';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
        loader: home
      },
      {
        path: 'work',
        element: <Work />,
        loader: works
      },
      {
        path: 'work/:slug',
        element: <CaseStudy />,
        loader: ({ params }) => work(params)
      },
      {
        path: 'services',
        element: <Services />
      },
      {
        path: 'Company',
        element: <Company />
      },
      {
        path: 'contact',
        element: <Contact />
      },
      {
        path: 'our-values',
        element: <OurValues />
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicy />
      }
      ,
      {
        path: 'terms-of-service',
        element: <TermsServices />
      }
    ]
  }
]);

export default function App() {
  return (
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  );
}
